<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="8" class="pr-1">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisiblePegawai()"
                                @blur="toggleCloseVisiblePegawai()"
                                v-model="queryPegawai"
                                v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                                @keydown.up="upPegawai"
                                @keydown.down="downPegawai"
                                @keydown.enter="selectItemPegawai"
                                placeholder="Pilih Pegawai"
                        >
                        <div class="popovers" v-show="visiblePegawai">
                            <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesPegawai"
                                    :key="index"
                                    :class="{ 'selected': (selectedPegawai == index)}"
                                    @click="itemClickedPegawai(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                                Start Typing...
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol sm="2" class="pr-1 pl-1">
                    <month-picker-input placeholder="Bulan" :no-default="true" :show-year="true" :default-year="date.year" @change="showDate"></month-picker-input>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-4" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-4 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:right;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                    <img class="mr-4 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :errors="errorMessage"></Tables>
        <CModal
            size="xl"
            :centered="true"
            color="white"
            :show.sync="detailModal"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Detail E-Overtime</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="detailModal = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="3">
                            Nama
                        </CCol>
                        <CCol sm="9">
                            : <span class="font-weight-bold">{{dataNama}}</span>
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="3">
                            NIP
                        </CCol>
                        <CCol sm="9">
                            : {{dataNik}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="3">
                            Jabatan
                        </CCol>
                        <CCol sm="9">
                            : {{dataJabatan}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="3">
                            Bidang
                        </CCol>
                        <CCol sm="9">
                            : {{dataBidang}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="3">
                            Total Jam
                        </CCol>
                        <CCol sm="9">
                            : {{dataTotalJam}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="3">
                            Periode
                        </CCol>
                        <CCol sm="9">
                            : {{dataBulan}} - {{dataTahun}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="12">
                            <table>
                                <thead>
                                    <tr>
                                        <th class="text-center" style="white-space:normal;word-wrap: break-word" rowspan="2">Hari</th>
                                        <th class="text-center" style="white-space:normal;word-wrap: break-word" rowspan="2">Tanggal</th>
                                        <th class="text-center" style="white-space:normal;word-wrap: break-word" rowspan="2">Status Hari</th>
                                        <th class="text-center" style="white-space:normal;word-wrap: break-word" rowspan="2">Jam Hadir</th>
                                        <th class="text-center" style="white-space:normal;word-wrap: break-word" rowspan="2">Total</th>
                                        <th class="text-center" style="white-space:normal;word-wrap: break-word" colspan="3">Hari Libur</th>
                                        <th class="text-center" style="white-space:normal;word-wrap: break-word" colspan="3">Hari Raya</th>
                                    </tr>
                                    <tr>
                                        <th class="text-center" style="white-space:normal;word-wrap: break-word;background-color:#f4f4f4;">2</th>
                                        <th class="text-center" style="white-space:normal;word-wrap: break-word;background-color:#f4f4f4;">3</th>
                                        <th class="text-center" style="white-space:normal;word-wrap: break-word;background-color:#f4f4f4;">4</th>
                                        <th class="text-center" style="white-space:normal;word-wrap: break-word;background-color:#f4f4f4;">3</th>
                                        <th class="text-center" style="white-space:normal;word-wrap: break-word;background-color:#f4f4f4;">4</th>
                                        <th class="text-center" style="white-space:normal;word-wrap: break-word;background-color:#f4f4f4;">5</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, id) in dataDetail" :key="id">
                                        <td style="white-space:normal;word-wrap: break-word">{{item.hari}}</td>
                                        <td style="white-space:normal;word-wrap: break-word">{{separatorTanggal(item.tanggal)}}</td>
                                        <td style="white-space:normal;word-wrap: break-word">
                                            <span v-if="item.hariRaya == 'K'">Hari Kerja</span>
                                            <span v-if="item.hariRaya == 'Y'">Hari Raya</span>
                                            <span v-if="item.hariRaya == 'N'">Hari Libur Biasa</span>
                                            <span v-if="item.hariRaya == 'C'">Cuti Bersama</span>
                                        </td>
                                        <td style="white-space:normal;word-wrap: break-word"><span :style="item.koreksiIn=='Y'&&'color:red'">{{item.jamMulai}}</span> - <span :style="item.koreksiOut=='Y'&&'color:red'">{{item.jamSelesai}}</span></td>
                                        <td class="text-center" style="white-space:normal;word-wrap: break-word">{{item.total}}</td>
                                        <td class="text-center" style="white-space:normal;word-wrap: break-word">{{item.dua}}</td>
                                        <td class="text-center" style="white-space:normal;word-wrap: break-word">{{item.tiga}}</td>
                                        <td class="text-center" style="white-space:normal;word-wrap: break-word">{{item.empat}}</td>
                                        <td class="text-center" style="white-space:normal;word-wrap: break-word">{{item.duaRaya}}</td>
                                        <td class="text-center" style="white-space:normal;word-wrap: break-word">{{item.tigaRaya}}</td>
                                        <td class="text-center" style="white-space:normal;word-wrap: break-word">{{item.empatRaya}}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-right font-weight-bold" style="background-color:#f4f4f4;white-space:normal;word-wrap: break-word" colspan="4">Total</td>
                                        <td class="text-center" style="white-space:normal;word-wrap: break-word">{{dataTotal}}</td>
                                        <td class="text-center" style="white-space:normal;word-wrap: break-word">{{dataTotal2}}</td>
                                        <td class="text-center" style="white-space:normal;word-wrap: break-word">{{dataTotal3}}</td>
                                        <td class="text-center" style="white-space:normal;word-wrap: break-word">{{dataTotal4}}</td>
                                        <td class="text-center" style="white-space:normal;word-wrap: break-word">{{dataTotal2r}}</td>
                                        <td class="text-center" style="white-space:normal;word-wrap: break-word">{{dataTotal3r}}</td>
                                        <td class="text-center" style="white-space:normal;word-wrap: break-word">{{dataTotal4r}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </CCol>
                    </CRow>
                </div>
                <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol sm="12">
                        <CButton @click="detailModal = false" class="btn-cancel">Kembali</CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableEOvertime'
import {DataApi} from "../../../service/DataApi";
import { MonthPickerInput } from 'vue-month-picker'

export default {
    components: {
        Tables,
        MonthPickerInput
    },
    data() {
        return {
            // data search pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,


            success: true,
            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            classReload: 'reloadOff',
            datas: [],
            goArea: true,
            loading: false,
            loadingReject: false,
            alertMess: '',
            currentAlertCounter: 0,

            // data model

            detailModal: false,

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            date: {
                from: null,
                to: null,
                month: null,
                monthIndex: null,
                year: null
            },

            // data
            dataBulan: '',
            dataBidang: '',
            dataJabatan: '',
            dataNama: '',
            dataNik: '',
            dataTahun: '',
            dataTotalJam: '',
            dataTotal: '',
            dataTotal2: '',
            dataTotal2r: '',
            dataTotal3: '',
            dataTotal3r: '',
            dataTotal4: '',
            dataTotal4r: '',

            dataDetail: [],

            tanggal: new Date(),

            // error
            errorMessage: '',
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryPegawai() {
            this.flagSearch = true
            this.getDataPegawai()
        },
        date() {
            this.flagSearch = true
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        }
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
    },
    methods: {
        /**
         * SEARCH PEGAWAI
         */
        getDataPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },

        setDate() {
            let month = this.tanggal.getMonth() + 1
            let year = this.tanggal.getFullYear()
            this.date.monthIndex = month
            this.date.year = year
        },
        showDate(date) {
            this.date = date
        },


        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.alamat.toLowerCase() < b.alamat.toLowerCase()) {
                        return -1
                    }
                    if (a.alamat.toLowerCase() > b.alamat.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.kota.toLowerCase() < b.kota.toLowerCase()) {
                        return -1
                    }
                    if (a.kota.toLowerCase() > b.kota.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.provinsi.toLowerCase() < b.provinsi.toLowerCase()) {
                        return -1
                    }
                    if (a.provinsi.toLowerCase() > b.provinsi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.latitude.toLowerCase() < b.latitude.toLowerCase()) {
                        return -1
                    }
                    if (a.latitude.toLowerCase() > b.latitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.longitude.toLowerCase() < b.longitude.toLowerCase()) {
                        return -1
                    }
                    if (a.longitude.toLowerCase() > b.longitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.radius.toLowerCase() < b.radius.toLowerCase()) {
                        return -1
                    }
                    if (a.radius.toLowerCase() > b.radius.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let payload = {
                bulan: this.date.monthIndex,
                limit: this.size,
                nama: this.queryPegawai.split(" - ")[0],
                pageIn: this.page,
                tahun: this.date.year
            }
            DataApi.post("/overtime/rekap/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        getDownload() {
            if(this.datas.length != 0) {
                this.$store.state.loadingScreen = true
                let payload = {
                    bulan: this.date.monthIndex,
                    limit: this.totalRow,
                    nama: this.queryPegawai.split(" - ")[0],
                    pageIn: 1,
                    tahun: this.date.year
                }
                DataApi.post("/export/overtime/rekap/lihat", payload , {responseType: 'blob'})
                .then(res => {
                    let response = res.data
                    // let fileName = res.headers["content-disposition"].split("filename=")[1];
                    const url = URL.createObjectURL(new Blob([response], {
                        type: 'application/vnd.ms-excel'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'Detail E-Overtime')
                    document.body.appendChild(link)
                    link.click()
                    this.$store.state.loadingScreen = false
                })
            }
        },
        findData() {
            this.getData()
        },
        reload() {
            this.queryPegawai = ''
            this.flagSearch = true
            this.getData()
            this.setDate()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.err = ''
            }
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            let id = generate.idPegawai
            let payload = {
                bulan: this.date.monthIndex,
                idPegawai: id,
                tahun: this.date.year
            }
            DataApi.post("/overtime/rekap/detail/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let temp = response.data
                    this.dataDetail = temp.data

                    if(temp.bulan == '1') {
                        this.dataBulan = 'Januari'
                    } else if(temp.bulan == '2') {
                        this.dataBulan = 'Februari'
                    } else if(temp.bulan == '3') {
                        this.dataBulan = 'Maret'
                    } else if(temp.bulan == '4') {
                        this.dataBulan = 'April'
                    } else if(temp.bulan == '5') {
                        this.dataBulan = 'Mai'
                    } else if(temp.bulan == '6') {
                        this.dataBulan = 'Juni'
                    } else if(temp.bulan == '7') {
                        this.dataBulan = 'Juli'
                    } else if(temp.bulan == '8') {
                        this.dataBulan = 'Agustus'
                    } else if(temp.bulan == '9') {
                        this.dataBulan = 'September'
                    } else if(temp.bulan == '10') {
                        this.dataBulan = 'Oktober'
                    } else if(temp.bulan == '11') {
                        this.dataBulan = 'November'
                    } else if(temp.bulan == '12') {
                        this.dataBulan = 'Desember'
                    }

                    this.dataBidang = temp.bidang
                    this.dataJabatan = temp.jabatan
                    this.dataNama = temp.nama
                    this.dataNik = temp.nik
                    this.dataTahun = temp.tahun
                    this.dataTotal = temp.total
                    this.dataTotalJam = temp.totalJam
                    this.dataTotal2 = temp.total2
                    this.dataTotal2r = temp.total2r
                    this.dataTotal3 = temp.total3
                    this.dataTotal3r = temp.total3r
                    this.dataTotal4 = temp.total4
                    this.dataTotal4r = temp.total4r

                    this.detailModal = true
                }
            })
        },
        separatorTanggal(val) {
            let tanggal = val.split("-")[2]
            let bulanTemp = val.split("-")[1]
            let tahun = val.split("-")[0]
            let bulan = ''
            if(bulanTemp == '01' || bulanTemp == '1') {
                bulan = 'Jan'
            } else if(bulanTemp == '02' || bulanTemp == '2') {
                bulan = 'Feb'
            } else if(bulanTemp == '03' || bulanTemp == '3') {
                bulan = 'Mar'
            } else if(bulanTemp == '04' || bulanTemp == '4') {
                bulan = 'Apr'
            } else if(bulanTemp == '05' || bulanTemp == '5') {
                bulan = 'Mei'
            } else if(bulanTemp == '06' || bulanTemp == '6') {
                bulan = 'Jun'
            } else if(bulanTemp == '07' || bulanTemp == '7') {
                bulan = 'Jul'
            } else if(bulanTemp == '08' || bulanTemp == '8') {
                bulan = 'Agu'
            } else if(bulanTemp == '09' || bulanTemp == '9') {
                bulan = 'Sep'
            } else if(bulanTemp == '10') {
                bulan = 'Okt'
            } else if(bulanTemp == '11') {
                bulan = 'Nov'
            } else if(bulanTemp == '12') {
                bulan = 'Des'
            }
            return tanggal + ' ' + bulan + ' ' + tahun
        },

    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataPegawai()
        this.setDate()
    }
}
</script>
<style scoped>
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: right;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: right;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-edit-delete {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.invalid-feedback {
    margin-top: -16px;
    float: right;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
.modal-button-cancel {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: white;
    color: rgba(16, 16, 16, 1);
}
.modal-button-cancel:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
::v-deep .month-picker__container {
    z-index: 5 !important;
    width: 250px;
}
::v-deep .month-picker__year button {
    width: 50px;
    height: 48px;
}
::v-deep .month-picker-input {
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    background-clip: padding-box;
    border: 1px solid;
    color: #768192;
    border-color: #d8dbe0;
    background-color: #f9fafc;
    border-radius: .25rem;
}
::v-deep .month-picker-input-container {
    width: 100%;
    min-width: none;
}
</style>
